import classNames from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './Navigation.module.scss'

interface INavigationItemProps {
  isActive?: boolean
  title: string
  onStepChange: () => void
  isDisabled?: boolean
}

export const NavigationItem: FC<INavigationItemProps> = ({
  title,
  isActive,
  onStepChange,
  isDisabled,
}) => {
  return (
    <a
      onClick={onStepChange}
      className={classNames(styles.item, {
        [styles['item_active']]: isActive,
        [styles['disabled']]: isDisabled && !isActive,
      })}
    >
      <span className={styles.item__inner}>
        <div className={styles.item__title}>
          <Translation text={title} />
        </div>
      </span>
    </a>
  )
}
